<template>
  <section class="content-padding">
    <div class="row" v-if="referralCode">
      <div class="col-12 col-sm-6 offset-sm-3">
        <img src="https://beneat.co/images/invite-friends.png" alt="" class="img-fluid rounded">

        <div class="pt-4">
          <h2 class="mb-2">{{ $t('message.invite_friends.header_title') }}</h2>
          <div>
            {{ $t('message.invite_friends.header_detail') }}
          </div>
        </div>

        <div class="card mt-4" v-if="creditStats">
          <div class="card-body shadow-sm">
            <div class="row no-gutters text-remark text-dark">
              <div class="col-12">
                <h3>{{ $t('message.invite_friends.your_stats') }}</h3>
              </div>
              <div class="col-8 text-info">
                {{ $t('message.invite_friends.total_friends') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ creditStats.total_friends }}</label>
              </div>
              <div class="col-8 text-info">
                {{ $t('message.invite_friends.booked_friends') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ creditStats.booked_friends }}</label>
              </div>
              <div class="col-12"><hr></div>
              <div class="col-8 text-info">
                {{ $t('message.invite_friends.acquired_coins') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ creditStats.acquired_credits | currency }}</label>
              </div>
              <div class="col-8 text-secondary">
                {{ $t('message.invite_friends.remaining_coins') }}
              </div>
              <div class="col-4 text-right">
                <label>{{ (creditStats.total_credits - creditStats.acquired_credits) | currency }}</label>
              </div>
            </div>
          </div>
        </div>

        <div class="pt-4">
          <h3>{{ $t('message.invite_friends.header_share_link') }}</h3>
          <div class="input-group flex-fill">
            <input ref="referralCode"
                   class="form-control flex-fill"
                   type="text"
                   :value="'beneat.co/chat-booking?c='+referralCode.referral_code">
            <div class="input-group-append">
              <button class="btn btn-info"
                      @click="copyReferralCode"
                      v-clipboard:copy="referralCode.url_referral_code">
                {{ $t(isCopiedReferralCode) }}
              </button>
            </div>
          </div>
        </div>

        <div class="my-4">
          <hr>
        </div>

        <div class="my-3">
          <a class="btn btn-block btn-lg -indigo my-2"
             :href="'https://www.facebook.com/sharer/sharer.php?u='+referralCode.url_referral_code"
             target="_blank">
            <i class="fab fa-facebook-f mr-3"></i> Share on Facebook
          </a>
        </div>

        <div class="my-3">
          <a class="btn btn-block btn-lg -blue my-2"
             :href="'https://twitter.com/intent/tweet?url='+referralCode.url_referral_code"
             target="_blank">
            <i class="fab fa-twitter mr-3"></i> Share on Twitter
          </a>
        </div>

        <div class="my-3">
          <a class="btn btn-block btn-lg -green-line my-2"
             :href="'https://social-plugins.line.me/lineit/share?url='+referralCode.url_referral_code"
             target="_blank">
            <i class="fab fa-line mr-3"></i> Share on LINE
          </a>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'

  export default {
    data () {
      return {
        refCode: null,
        creditStats: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        referralCode: 'referralCode/getReferralCode',
        user: 'auth/getUser'
      }),
      isCopiedReferralCode () {
        return (this.refCode) ? 'message.button.copied' : 'message.button.copy'
      }
    },
    methods: {
      copyReferralCode () {
        this.refCode = this.$refs.referralCode.value
      },
      fetchUserCreditStats (userId) {
        const url = `/users/${userId}/credit-stats`
        axios.get(url)
          .then(res => {
            const response = res.data
            this.creditStats = response.credit_stats
          })
          .catch(error => {
            console.log('DEBUG', error)
          })
      }
    },
    mounted () {
      if (this.$route.query.user_id) {
        const userId = this.$route.query.user_id
        this.$store.dispatch('referralCode/LOAD_REFERRAL_CODE_DETAIL', userId)
        this.fetchUserCreditStats(userId)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/InviteFriendCampaign.vue